import { useTenant } from "hooks/settings";
import dayjs from "dayjs";
import { useGetRailcarMovementsQuery } from "src/store/api/generatedApi";

export const useRailcarMovementsBetween = (
  startTime: dayjs.Dayjs,
  endTime: dayjs.Dayjs
) => {
  const tenantName = useTenant();
  const response = useGetRailcarMovementsQuery({
    tenantName,
    startTime: startTime.utc().toISOString(),
    endTime: endTime.utc().toISOString(),
  });
  return {
    railcarMovements: response.data ?? { railcar_movements: [] },
    isFetching: response.isFetching,
    isError: response.isError,
  };
};
